/**
 * Check if a subscription tier is a paid/premium tier.
 * Any tier other than 'free' is considered premium.
 */
export function isPremiumTier(tier: string | undefined | null): boolean {
  return !!tier && tier !== 'free';
}
